import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Widgets */
import Information from "./Information"
import Sessions from "./Sessions"
import Rounds from "./Rounds"

/* Icons */
import { CloseIcon, InfoIcon, SessionIcon, RoundIcon } from "./PlayerIcons"

/* Translate */
import { t } from "../../translates/translate"


/* Tabs */
const INFORMATION = "information"
const SESSIONS = "sessions"
const ROUNDS = "rounds"


/* Widget Player View */
class PlayerView extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            tab: INFORMATION,
            player: null,
            isTester: 0,
            sid: "",
            table: null,
        }

        this._scroll = null
    }

    /* Open Action */
    open = ({ player, isTester = 0 }) => {

        /* Check Parameters */
        if (!player) {
            return
        }

        this.setState({ visible: true, tab: INFORMATION, player, isTester, sid: "", table: null })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, tab: INFORMATION, player: null, isTester: 0, sid: "", table: null })
    }

    /* Open The Rounds Of One Session — the way from the sessions deeper into the hands */
    openSession = (sid) => {
        this.setState({ tab: ROUNDS, sid: sid ? String(sid) : "", table: null }, () => this.scrollToTop())
    }

    /* Open The Rounds Of One Game — the numbers of a game are its rounds */
    openGame = (table) => {
        this.setState({ tab: ROUNDS, sid: "", table }, () => this.scrollToTop())
    }

    /* Change Tab — a tab opened by hand starts clean, without the filter of another tab */
    changeTab = (tab) => {
        this.setState({ tab, sid: "", table: null }, () => this.scrollToTop())
    }

    /* Scroll To Top */
    scrollToTop = () => {
        if (this._scroll) {
            this._scroll.scroll({ top: 0, behavior: "smooth" })
        }
    }

    /* Get Tabs */
    getTabs = () => [
        { key: INFORMATION, text: t("player.information"), icon: <InfoIcon size={15} /> },
        { key: SESSIONS, text: t("player.sessions"), icon: <SessionIcon size={15} /> },
        { key: ROUNDS, text: t("player.roundsTab"), icon: <RoundIcon size={15} /> },
    ]

    render = () => {

        /* Fields */
        const { visible, tab, player, isTester, sid, table } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="plr--modal wide"
                overlayClassName="plr--overlay"
                closeTimeoutMS={200}
            >

                {/* Draw Header */}
                <div className="plr--modal-header">

                    <div className="plr--modal-icon blue">
                        <RoundIcon size={18} />
                    </div>

                    <div className="plr--modal-head-text">
                        <h2>{t("player.statsTitle")}</h2>
                        <p>{player}</p>
                    </div>

                    <div onClick={() => this.close()} className="plr--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                {/* Draw Tabs */}
                <div className="plr--tabs">
                    {this.getTabs().map((item, index) =>
                        <div onClick={() => this.changeTab(item.key)} className={`plr--tab ${tab === item.key ? "active" : ""}`} key={`${index}`}>
                            {item.icon}
                            <span>{item.text}</span>
                        </div>
                    )}
                </div>

                {/* Draw Content (key по игроку — чтобы виджет перезагружался при смене игрока) */}
                <div className="plr--modal-body" ref={(ref) => this._scroll = ref}>

                    {tab === INFORMATION &&
                        <Information key={`information-${player}`} player={player} isTester={isTester} openGame={this.openGame} />
                    }

                    {tab === SESSIONS &&
                        <Sessions key={`sessions-${player}`} player={player} openSession={this.openSession} />
                    }

                    {tab === ROUNDS &&
                        <Rounds
                            key={`rounds-${player}-${sid}-${table ? table.id : "all"}`}
                            player={player}
                            sid={sid}
                            table={table}
                            clearSession={() => this.setState({ sid: "" })}
                            scrollToTop={this.scrollToTop}
                        />
                    }

                </div>

            </Modal>
        )
    }

}

export default PlayerView
